import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';

import { OperadorInfopedidoPage } from '../operador-infopedido/operador-infopedido';
import { OperadorOperacaoPage } from '../operador-operacao/operador-operacao';
import { OperadorCaixasPage } from '../operador-caixas/operador-caixas';
import { WelcomePage } from '../welcome/welcome';

import { Services, Tools, User, Api } from '../../providers';

@IonicPage()
@Component({
  selector: 'page-operador-pedidos',
  templateUrl: 'operador-pedidos.html',
})
export class OperadorPedidosPage {
  separacao:any={_id:false};
  pedidos:any=[];
  pedidosorig:any=[];
  url:any = 'http://barbosa.ibrs.com.br:5000/api/tracking/listarpedidos';

  separacaoLS:any={};
  carrinho:any={
    pedidosId:[],
    pedidos:0,
    produtos:0
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private api: Api,
    private user: User,
    private services: Services,
    private tools: Tools
  ) {
  }

  ionViewDidLoad() {
    this.loadList();
  }

  loadList2(){
    let loading = this.tools.showLoading('Carregando...');
    loading.present();
    let self = this;

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "lojaId":this.user.getUser().lojaId+''
    }

    this.api.sendPost(this.url,postObj,{},(result2)=>{
      console.log(result2);
      if(result2.status){
        self.services.getData('cadSeparacoes',{status:'warning',operadorId:self.user.getUser()._id,ativo:true},(result)=>{
          console.log('cadPedidos: ',result2);
          console.log('cadSeparacoes: ',result);

          let newdata = result2.data.map(e=>{
            e.filter = e.cliente.nome+' - '+e.pedido.codigo;
            return e;
          });

          self.pedidosorig = newdata.concat([]);
          self.pedidos = newdata.concat([]);

          if(result.data.length>0){
            self.separacao = result.data[result.data.length-1];

            this.tools.storage('load','separacao',null,(resultLS)=>{
              console.log(resultLS);

              if(resultLS.status){
                this.separacaoLS = JSON.parse(resultLS.data);
                if(this.separacaoLS.timeupd > self.separacao.timeupd){
                  self.separacao = this.separacaoLS;
                  this.tools.showAlert('toast','Pedido LS Mais Atualizado');
                }
              }

              self.carrinho.pedidosId = self.separacao.pedidosId;
              self.carrinho.pedidos = self.separacao.totalPedidos;
              self.carrinho.produtos = self.separacao.items.length;
              self.carrinho._id = self.separacao._id;

            });

          }else{
            self.carrinho.pedidosId = [];
            self.carrinho.pedidos = 0;
            self.carrinho.produtos = 0;
            self.separacao._id = false;
          }
          loading.dismiss();
        });
      }else{
        self.tools.storage('load','separacao',null,(e)=>{
          console.log(e);

          if(e.status){
            self.separacao = JSON.parse(e.data);

            self.carrinho.pedidosId = self.separacao.pedidosId;
            self.carrinho.pedidos = self.separacao.totalPedidos;
            self.carrinho.produtos = self.separacao.totalProdutos;
            self.carrinho._id = self.separacao._id;
            self.tools.showAlert('toast','Sem Internet, Pedido Encontrado');
          }else{
            self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
          }
          loading.dismiss();
        });
      }

    });
  }

  loadList(){
    let loading = this.navParams.get('item');
    let self = this;

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "lojaId":this.user.getUser().lojaId+''
    }

    this.api.sendPost(this.url,postObj,{},(result2)=>{
      if(result2.status){
        self.services.getData('cadSeparacoes',{status:'warning',operadorId:self.user.getUser()._id,ativo:true},(result)=>{
          console.log('cadPedidos: ',result2);
          console.log('cadSeparacoes: ',result);

          let newdata = result2.data.map(e=>{
            e.filter = e.cliente.nome+' - '+e.pedido.codigo;
            return e;
          });

          self.pedidosorig = newdata.concat([]);
          self.pedidos = newdata.concat([]);

          if(result.data.length>0){
            self.separacao = result.data[result.data.length-1];

            this.tools.storage('load','separacao',null,(resultLS)=>{
              console.log(resultLS);

              if(resultLS.status){
                this.separacaoLS = JSON.parse(resultLS.data);
                if(this.separacaoLS.timeupd > self.separacao.timeupd){
                  self.separacao = this.separacaoLS;
                  this.tools.showAlert('toast','Pedido LS Mais Atualizado');
                }
              }

              self.carrinho.pedidosId = self.separacao.pedidosId;
              self.carrinho.pedidos = self.separacao.totalPedidos;
              self.carrinho.produtos = self.separacao.items.length;
              self.carrinho._id = self.separacao._id;

            });

          }
          loading.dismiss();
        });
      }else{
        self.tools.storage('load','separacao',null,(e)=>{
          console.log(e);

          if(e.status){
            self.separacao = JSON.parse(e.data);

            self.carrinho.pedidosId = self.separacao.pedidosId;
            self.carrinho.pedidos = self.separacao.totalPedidos;
            self.carrinho.produtos = self.separacao.totalProdutos;
            self.carrinho._id = self.separacao._id;
            self.tools.showAlert('toast','Sem Internet, Pedido Encontrado LocalStorage');
          }else{
            self.tools.showAlert('toast','Sem Internet, Nenhum Pedido Encontrado');
          }
          loading.dismiss();
        });
      }

    });
  }

  criar(){
    if(this.separacao._id){
      this.navCtrl.push(OperadorOperacaoPage,{item:this.separacao});
    }else{
      this.navCtrl.push(OperadorCaixasPage,{item:this.pedidos.filter(e=>this.carrinho.pedidosId.indexOf(e._id)>=0)});
    }
  }

  confirmCancel(separacao:any) {
    const confirm = this.alertCtrl.create({
      title: 'Deseja realmente cancelar essa separação?',
      message: 'Todos os itens separados serão zerados, esta ação é irreversível.',
      buttons: [
        {
          text: 'Não',
          handler: () => {
            console.log('Não clicked');
          }
        },
        {
          text: 'Sim',
          handler: () => {
            console.log('Sim clicked');
            this.cancelar(separacao);
          }
        }
      ]
    });
    confirm.present();
  }

  cancelar(separacao:any){
    var loading = this.tools.showLoading('Carregando');
    loading.present();

    var url = 'http://barbosa.ibrs.com.br:5000/api/tracking/cancelarsep';

    var postObj = {
      "app_key":"rtEVWH9FSjx6KoUxMxuN0uC6",
      "app_secret":"4rEyQRcvb0P4",
      "separacaoId":separacao._id+''
    }
    let self = this;
    this.api.sendPost(url,postObj,{},function(result){
      self.tools.storage('del','separacao',null,(e)=>{
        console.log(e);
        self.tools.showAlert('toast',result.msg);
        self.loadList2();
        loading.dismiss();
      });
    });
  }

  openPedido(pedido){
    this.navCtrl.push(OperadorInfopedidoPage,{item:pedido});
  }

  addCarrinho(pedido){
    var idx = this.carrinho.pedidosId.indexOf(pedido._id+'');
    if(idx<0){
      this.carrinho.pedidosId.push(pedido._id+'');
    }else{
      this.carrinho.pedidosId.splice(idx,1);
    }

    this.calcCarrinho();
  }

  calcCarrinho(){
    var pedidos = this.pedidos.filter(e=>this.carrinho.pedidosId.indexOf(e._id+'')>=0);
    this.carrinho.pedidos = pedidos.length;
    this.carrinho.produtos = pedidos.map(e=>e.items).flat().length;

  }

  getItems(event){
    if(event.target.value=='' || !event.target.value){this.pedidos=this.pedidosorig}
    else{
      this.pedidos = this.pedidosorig.filter(item=>{
        return (item.filter).toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
      });
    }
  }

  logout(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmação',
      message: 'Deseja realmete sair ?',
      buttons: [
        { text: 'Não', handler: () => {} },
        { text: 'Sim', handler: () => { this.navCtrl.setRoot(WelcomePage); } }
      ]
    });
    confirm.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/operador-pedidos/operador-pedidos.ts